"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var reducers_1 = require("../_shared/reducers");
var react_redux_1 = require("react-redux");
var PortalPage_1 = require("../_shared/components/PortalPage");
var model_1 = require("../../model");
var layout_1 = require("../_shared/components/layout");
var Modal = require("react-modal");
require("./styles.scss");
var server_1 = require("../../helpers/server");
var constants_1 = require("../../constants");
var ImportAddressesPage = /** @class */ (function (_super) {
    __extends(ImportAddressesPage, _super);
    function ImportAddressesPage(props) {
        var _this = _super.call(this, props) || this;
        _this.fetchImports = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.setState({ loading: true });
                try {
                    (0, server_1.get)(constants_1.API.IMPORTS_URI, {}).then(function (response) {
                        if (!response.success) {
                            console.error('Error loading imports:', response.message);
                            _this.setState({ loading: false });
                            return;
                        }
                        _this.setState({ imports: response.imports, loading: false });
                    });
                }
                catch (error) {
                    console.error('Error loading imports:', error);
                    this.setState({ loading: false });
                }
                return [2 /*return*/];
            });
        }); };
        _this.fetchStats = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.setState({ loadingStats: true });
                try {
                    (0, server_1.get)(constants_1.API.IMPORT_STATISTICS_URI, {}).then(function (response) {
                        if (!response.success) {
                            console.error('Error loading imports:', response.message);
                            _this.setState({ loadingStats: false });
                            return;
                        }
                        _this.setState({ loadingStats: false, stats: response.stats });
                    });
                }
                catch (error) {
                    console.error('Error loading imports:', error);
                    this.setState({ loadingStats: false });
                }
                return [2 /*return*/];
            });
        }); };
        // Handles file selection for CSV import
        _this.handleFileUpload = function (event) {
            var file = event.target.files ? event.target.files[0] : null;
            _this.setState({ selectedFile: file });
        };
        // Submits the selected CSV file and refreshes imports
        _this.handleImport = function () { return __awaiter(_this, void 0, void 0, function () {
            var selectedFile, formData, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectedFile = this.state.selectedFile;
                        if (!selectedFile) {
                            return [2 /*return*/];
                        }
                        formData = new FormData();
                        formData.append('file', selectedFile);
                        console.log('Uploading file:', selectedFile);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, (0, server_1.post)(constants_1.API.IMPORTS_URI, formData)];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, this.fetchImports()];
                    case 3:
                        _a.sent(); // Refresh list after import
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        console.error('Error importing file:', error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.handleStartImport = function (importId) { return __awaiter(_this, void 0, void 0, function () {
            var response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, (0, server_1.post)("".concat(constants_1.API.IMPORTS_URI, "/").concat(importId, "/"), {})];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.fetchImports()];
                    case 2:
                        _a.sent(); // Refresh list after import
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        console.error('Error starting import:', error_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // Displays failed items in an alert or modal (placeholder function)
        _this.showFailedDetails = function (importId) {
            _this.setState({ loadingFailedItems: true, showModal: true });
            try {
                (0, server_1.get)("".concat(constants_1.API.IMPORTS_URI, "/").concat(importId, "/failedItems"), {}).then(function (response) {
                    if (!response.success) {
                        console.error('Error loading imports:', response.message);
                        _this.setState({ loadingFailedItems: false });
                        return;
                    }
                    console.log('Failed items:', response.failedItems);
                    _this.setState({ loadingFailedItems: false, failedItems: response.failedItems });
                });
            }
            catch (error) {
                console.error('Error loading imports:', error);
                _this.setState({ loadingFailedItems: false, showModal: false });
            }
        };
        // Renders the imports table with details for failed imports
        _this.renderImportsTable = function () {
            var imports = _this.state.imports;
            return (React.createElement("table", { className: 'table' },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "Name"),
                        React.createElement("th", null, "Date"),
                        React.createElement("th", null, "Status"),
                        React.createElement("th", null, "Message"),
                        React.createElement("th", null, "Nr. of Imported Items"),
                        React.createElement("th", null, "Nr. of Failed Items"),
                        React.createElement("th", null, "Details"),
                        React.createElement("th", null, "Actions"))),
                React.createElement("tbody", null, imports.map(function (importItem) { return (React.createElement("tr", { key: importItem._id },
                    React.createElement("td", null, importItem.filePath),
                    React.createElement("td", null, importItem.date),
                    React.createElement("td", null, importItem.status),
                    React.createElement("td", null, importItem.message),
                    React.createElement("td", null, importItem.nImportedItems || '-'),
                    React.createElement("td", null, (importItem === null || importItem === void 0 ? void 0 : importItem.nFailedItems) || '-'),
                    React.createElement("td", null, (importItem === null || importItem === void 0 ? void 0 : importItem.nFailedItems) ? (React.createElement("button", { className: 'detailsButton', onClick: function () { return _this.showFailedDetails(importItem._id); } }, "View Details")) : ('-')),
                    React.createElement("td", null, importItem.status === 'pending' ? (React.createElement("button", { className: 'startButton', onClick: function () { return _this.handleStartImport(importItem._id); } }, "Start Import")) : ('-')))); }))));
        };
        _this.renderStatsSection = function () {
            var _a = _this.state, stats = _a.stats, loadingStats = _a.loadingStats;
            if (loadingStats) {
                return React.createElement("div", null, "Loading...");
            }
            if (!stats) {
                return React.createElement("button", { onClick: _this.fetchStats }, "Load Stats");
            }
            return (React.createElement(React.Fragment, null,
                React.createElement("h3", null, "Statistics"),
                React.createElement("p", null,
                    "Total Addresses: ",
                    stats.nAddresses),
                React.createElement("p", null,
                    "Waiting for location: ",
                    stats.nPendingAddresses),
                React.createElement("p", null,
                    "Failed to locate: ",
                    stats.nFailedAddresses),
                React.createElement("p", null,
                    "Imported in Last 24h: ",
                    stats.nAddressesLast24h),
                React.createElement("p", null,
                    "Waiting for location created in last 24h: ",
                    stats.nPendingAddressesLast24h),
                React.createElement("p", null,
                    "Failed to locate created in last 24h: ",
                    stats.nFailedAddressesLast24h)));
        };
        _this.state = {
            imports: [],
            failedItems: [],
            stats: null,
            loading: true,
            loadingStats: false,
            loadingFailedItems: false,
            selectedFile: null,
        };
        return _this;
    }
    ImportAddressesPage.prototype.componentDidMount = function () {
        this.fetchImports();
    };
    ImportAddressesPage.prototype.render = function () {
        var _this = this;
        var isLoading = this.props.isLoading;
        var _a = this.state, imports = _a.imports, loading = _a.loading, showModal = _a.showModal, failedItems = _a.failedItems, loadingFailedItems = _a.loadingFailedItems;
        return (React.createElement(PortalPage_1.default, { page: model_1.Permission.IMPORT_ADDRESES, isLoading: isLoading || loading, id: "report" },
            React.createElement(layout_1.Wrapper, null,
                React.createElement("div", { className: 'importSection' },
                    React.createElement("h3", null, "Import New Addresses"),
                    React.createElement("p", { className: 'description' }, "Please upload a CSV file to import new addresses. The list will update once the import is complete."),
                    React.createElement("input", { type: "file", accept: ".csv", onChange: this.handleFileUpload, className: 'fileInput' }),
                    React.createElement("button", { onClick: this.handleImport, disabled: !this.state.selectedFile, className: 'importButton' }, "Import")),
                React.createElement("div", { className: 'statsSection' }, this.renderStatsSection()),
                React.createElement("div", { className: 'tableSection' },
                    React.createElement("h3", null, "Recent Imports"),
                    this.renderImportsTable(),
                    React.createElement("button", { onClick: this.fetchImports, className: 'refreshButton' }, "Refresh List"))),
            showModal && (React.createElement(Modal, { isOpen: showModal || false, className: 'modal' },
                React.createElement("div", { className: "modal-content" },
                    React.createElement("span", { className: "modal_close_button", onClick: function () { return _this.setState({ showModal: false }); } }, "\u00D7"),
                    loadingFailedItems ? (React.createElement("p", null, "Loading...")) : (React.createElement("pre", null, JSON.stringify(failedItems, null, 2))))))));
    };
    return ImportAddressesPage;
}(react_1.Component));
var mapDispatchToProps = function (dispatch) { return ({
    logout: function () { return reducers_1.LoginActions.logout()(dispatch); }
}); };
exports.default = (0, react_redux_1.connect)(null, mapDispatchToProps)(ImportAddressesPage);
